(() => {
  const initializeSizeGuides = (root = document) => {
    root.querySelectorAll('[data-vivicat-size-guide]').forEach((guide) => {
      if (guide.dataset.initialized === 'true') return;

      const sectionId = guide.dataset.sectionId;
      const tables = document.querySelectorAll(`#ProductInfo-${sectionId} .product__description table`);
      const source = Array.from(tables).find((table) => /身丈|身幅|肩幅|袖丈/.test(table.textContent));
      const target = guide.querySelector('[data-vivicat-size-guide-content]');
      const opener = document.querySelector(`[data-vivicat-size-guide-opener="${sectionId}"]`);

      if (!source || !target || !opener) return;

      target.replaceChildren(source.cloneNode(true));
      opener.hidden = false;
      guide.dataset.initialized = 'true';
    });
  };

  const extractShippingDates = (text) => {
    const matches = Array.from(text.matchAll(/(?:(\d{4})-)?(\d{2})-(\d{2})/g));
    let currentYear = null;

    return matches
      .map((match) => {
        if (match[1]) currentYear = Number(match[1]);
        if (!currentYear) return null;
        return new Date(currentYear, Number(match[2]) - 1, Number(match[3]));
      })
      .filter((date) => date && !Number.isNaN(date.getTime()));
  };

  const formatShippingDate = (date) => `${date.getMonth() + 1}/${date.getDate()}`;

  const initializeShippingGuides = (root = document) => {
    root.querySelectorAll('[data-vivicat-shipping-guide]').forEach((guide) => {
      if (guide.dataset.initialized === 'true') return;

      const sectionId = guide.dataset.sectionId;
      const tables = document.querySelectorAll(`#ProductInfo-${sectionId} .product__description table`);
      const source = Array.from(tables).find((table) => /\d{4}-\d{2}-\d{2}/.test(table.textContent));
      const target = guide.querySelector('[data-vivicat-shipping-guide-content]');
      const summary = document.querySelector(`[data-vivicat-shipping-summary="${sectionId}"]`);
      const range = summary?.querySelector('[data-vivicat-shipping-range]');

      if (!source || !target || !summary || !range) return;

      const dates = extractShippingDates(source.textContent).sort((a, b) => a - b);
      if (dates.length === 0) return;

      const earliest = dates[0];
      const latest = dates[dates.length - 1];
      const shippingTable = source.cloneNode(true);

      shippingTable.querySelectorAll('*').forEach((element) => {
        element.removeAttribute('style');
        element.removeAttribute('width');
      });
      shippingTable.removeAttribute('style');
      shippingTable.removeAttribute('width');

      range.textContent = `${formatShippingDate(earliest)}〜${formatShippingDate(latest)}ごろ発送`;
      target.replaceChildren(shippingTable);
      summary.hidden = false;
      guide.dataset.initialized = 'true';
    });
  };

  const initializeProductGuides = (root = document) => {
    initializeSizeGuides(root);
    initializeShippingGuides(root);
  };

  document.addEventListener('DOMContentLoaded', () => initializeProductGuides());
  document.addEventListener('shopify:section:load', (event) => initializeProductGuides(event.target));
})();
